import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';

function AuthMain() {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    // Immediate redirect to Okta
    if (authState && !authState.isPending && !authState.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  // If the user is authenticated, redirect using Okta's stored originalUri or default to search
  if (authState && authState.isAuthenticated) {
    const redirectUri = oktaAuth.getOriginalUri();
    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
    if (originalUri && originalUri.length > 2 && originalUri !== '/search') {
      return <Navigate to={originalUri} replace />;
    }
    if (!redirectUri || redirectUri.length < 2) {
      return <Navigate to="/search" replace />;
    }
    return <Navigate to={redirectUri} replace />;
  }

  // If the user is NOT authenticated, and the redirect has already fired.
  return null;
}

export default AuthMain;
